import React, { Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
const ShortlistedCandidates = lazy(() => import('./../views/app/client/shortlistedcandidates'));
const ClientShortlisted = lazy(() => import('./../views/app/client/clientshortlisted'));

const ClientRoutes = () => {

    const sdparams = "?p=hms"+"&id=" + window.localStorage.getItem("hmsid");
    return (
        <Suspense fallback="loading...">
            <Switch>
                <Route exact path={"/sd"} params={sdparams} component={ShortlistedCandidates} />
                    <Route path="/cs" params={sdparams} component={ClientShortlisted} />
                <Redirect to={"/sd"}  params={sdparams} />
            </Switch>
        </Suspense>
    );
}

export default ClientRoutes;